import { ReactElement } from 'react';

import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { Internship } from '@backrs_ui/common-ui/src/models/internship';

import { Box, SxProps, Theme, Typography } from '@mui/material';

import { InternshipLineItem } from './InternshipLineItem';

const { QUICK_LOOK, SECTION_TITLES, notAvailable } = appStrings.modules.nugget.internship;

type QuickLookProps = Readonly<{
  internshipInfo: Internship;
}>;

export function QuickLook({ internshipInfo }: QuickLookProps): ReactElement {
  const valueMap: Record<string, string> = {
    [QUICK_LOOK.type]: internshipInfo.role_type || notAvailable,
    [QUICK_LOOK.path]:
      internshipInfo.careerPaths?.map((careerPath) => careerPath.name).join(', ') || notAvailable,
    [QUICK_LOOK.track]: notAvailable, // once this is actually mapped, update with internshipInfo.track
    [QUICK_LOOK.industry]: internshipInfo.industry_name || notAvailable,
    [QUICK_LOOK.location]: internshipInfo.location || notAvailable,
    [QUICK_LOOK.deadline]: internshipInfo.apply_by_date
      ? new Date(internshipInfo.apply_by_date).toLocaleDateString()
      : notAvailable,
  };

  return (
    <Box sx={containerStyle}>
      <Box>
        <Typography variant="body1" sx={sectionTitleStyle}>
          {SECTION_TITLES.quickLook}
        </Typography>

        {Object.entries(valueMap).map(([title, value]) => (
          <InternshipLineItem key={title} title={title} value={value} />
        ))}
      </Box>

      {(internshipInfo.application_url || internshipInfo.company_website) && (
        <Box
          component="a"
          href={internshipInfo.application_url || internshipInfo.company_website}
          target="_blank"
        >
          <Typography variant="body1" sx={linkStyle}>
            {SECTION_TITLES.applicationLink}
          </Typography>
        </Box>
      )}
    </Box>
  );
}

const sectionTitleStyle: SxProps<Theme> = {
  fontWeight: 700,
  color: appColors.color.blue1,
  mb: 1,
};

const containerStyle: SxProps<Theme> = {
  justifyContent: 'space-between',
  flexDirection: 'column',
  display: 'flex',
  height: '100%',
};

const linkStyle: SxProps<Theme> = {
  color: appColors.color.blue1,
  textDecoration: 'underline',
  textDecorationColor: appColors.color.blue1,
  fontWeight: 700,
  mt: 1,
};
